import axios from 'axios'

const base = (process.env.REACT_APP_API_BASE || 'http://127.0.0.1:5000').replace(/\/+$/,'')
const http = axios.create({ baseURL: base, withCredentials: false })

export function getToken() {
  return localStorage.getItem('token') || localStorage.getItem('jwt') || localStorage.getItem('access_token')
}
export function getTokenPayload() {
  const t = getToken()
  if (!t) return null
  try {
    const [, payload] = t.split('.')
    return JSON.parse(atob(payload.replace(/-/g,'+').replace(/_/g,'/')))
  } catch { return null }
}

http.interceptors.request.use((cfg) => {
  const token = getToken()
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

http.interceptors.response.use(
  r => r,
  (err) => {
    const status = err?.response?.status
    if (status === 401 || status === 403) {
      console.warn('Not authorised — connecte you.')
    }
    return Promise.reject(err)
  }
)

export default http
export const API_BASE = base
